// extracted by mini-css-extract-plugin
export var compactFilters = "_e5-4";
export var detailImage = "_e5-1";
export var dropdownContainer = "_e5-2";
export var imageContainer = "_e5-0";
export var selectedCard = "_e5-3";